import React, { useContext } from 'react';
import * as S from './style';
import { PartnerAuthState } from 'stores/PartnerAuthStore';

import { ReactComponent as IconKakaoLogo } from 'assets/img/footer/ic_kakao_white.svg';
import { ReactComponent as IconPhone } from 'assets/img/footer/ic_phone.svg';
import { ReactComponent as IconTimer } from 'assets/img/footer/ic_timer.svg';

function Footer(): React.ReactElement {
  const { service } = useContext(PartnerAuthState);
  const airBridgePartnerAppLink = 'https://abr.partner.zimssa.com/e33gqz'; // 짐싸 파트너 앱 링크

  return (
    <S.Footer>
      {(() => {
        if (
          service &&
          service.some(
            (item) =>
              ['interview_approve', 'approve_check', 'approve'].includes(
                item.serviceDocStatus
              ) && ['sign_up', 'active'].includes(item.serviceActiveStatus)
          )
        ) {
          return (
            <S.AppDown>
              <S.AppDownContainer>
                <S.AppDownWrapper>
                  <S.AppDownIconWrapper>
                    <S.AppDownLogo
                      src={`${process.env.REACT_APP_S3_URL}/partner-web/icons/ic_partner_app_down_log.png`}
                    />
                  </S.AppDownIconWrapper>

                  <S.AppDownTextWrapper>
                    모바일에서 <b>짐싸 파트너</b> 앱을 다운받으세요!
                  </S.AppDownTextWrapper>
                </S.AppDownWrapper>
                <S.AppDownWrapper>
                  <S.AppDownButtonWrapper>
                    <S.AppDownButton
                      href={airBridgePartnerAppLink}
                      target="_blank"
                    >
                      다운로드
                    </S.AppDownButton>
                  </S.AppDownButtonWrapper>
                </S.AppDownWrapper>
              </S.AppDownContainer>
            </S.AppDown>
          );
        }
      })()}
      <S.CompInfo>
        <S.CompInfoContainer>
          <S.CompInfoWrapper>
            <S.LogoContainer>
              <S.IconZimssa />
            </S.LogoContainer>
            <S.InfoWrapper>
              <S.Text>주식회사 짐싸</S.Text>
              <S.TextWrapper space={'12'}>
                <S.Text color={'white_opacity_600'}>대표</S.Text>
                <S.Text>한성배</S.Text>
              </S.TextWrapper>
            </S.InfoWrapper>
            <S.InfoWrapper>
              <S.Text color={'white_opacity_600'}>사업자 등록번호</S.Text>
              <S.Text>336-87-00759</S.Text>
            </S.InfoWrapper>
            <S.InfoWrapper>
              <S.Text>서울시 강남구 테헤란로 302 위워크타워 14층</S.Text>
            </S.InfoWrapper>
          </S.CompInfoWrapper>
          <S.CompInfoWrapper>
            <S.InfoWrapper>
              <S.IconWrapper>
                <IconKakaoLogo />
              </S.IconWrapper>
              <S.TextFlexWrapper>
                <S.Text font={'body2'} color={'gray_opacity_50'}>
                  카카오톡에서
                </S.Text>
                <S.Text font={'body2'} color={'gray_opacity_50'}>
                  <b>짐싸 파트너</b>를 검색하세요
                </S.Text>
              </S.TextFlexWrapper>
            </S.InfoWrapper>
            <S.InfoWrapper>
              <S.IconWrapper>
                <IconPhone />
              </S.IconWrapper>
              <S.TextFlexWrapper>
                <S.Text font={'body2'}>짐싸 고객센터 </S.Text>
                <S.Text font={'body2_bold'}>1833-2427</S.Text>
              </S.TextFlexWrapper>
            </S.InfoWrapper>
            <S.InfoWrapper>
              <S.IconWrapper>
                <IconTimer />
              </S.IconWrapper>
              <S.TextFlexWrapper>
                <S.Text font={'body2'}>운영시간</S.Text>
                <S.Text font={'body2_bold'}>
                  연중무휴 오전 9시 ~ 오후 6시 (점심시간 12:30 ~ 13:30)
                </S.Text>
              </S.TextFlexWrapper>
            </S.InfoWrapper>
          </S.CompInfoWrapper>
        </S.CompInfoContainer>
      </S.CompInfo>
    </S.Footer>
  );
}

export default Footer;
